<template>
    <div>

    </div>
</template>

<script>
    export default {
        name: "Next",
        methods : {
            getNextChapter (){
                this.axios.post('/api/chapter/next',{
                    bookid : this.$route.params.bid,
                    chapterid : this.$route.params.cid
                }).then(r => {
                    let data = r.data;
                    if(data.code){
                        this.$router.push({
                            name : 'Chapter',
                            params : {
                                wid : this.$route.params.bid,
                                cid : data.data.id
                            }
                        });
                    }else{
                        this.$message.error(data.msg);
                    }
                })
            }
        },created(){
            this.getNextChapter();
        }
    }
</script>

<style lang="less">

</style>
